import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import {
  ISectionSchema,
  RoleDetailSchema,
  RoleSchema,
} from "../../Schemas/Role";

interface Filter extends IFilterSchema {
  column: SectionListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: SectionListColumnSortable;
}

export enum SectionListColumnFilterable {
  ID = "id",
  CAPTION = "caption",
  CREATED_AT = "created_at",
}
export enum SectionListColumnSortable {
  ID = "id",
  CAPTION = "caption",
  CREATED_AT = "created_at",
}

interface ICreateRolePayload {
  caption: string;
  group: string;
  section_key: string;
  description: string;
}

export interface SectionListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface SectionListResponseBody extends IResponseBody {
  data: {
    acl_sections: ISectionSchema[];
    total: number;
  };
}
export interface SectionCreateResponseBody extends IResponseBody {
  data: {
    acl_role: RoleSchema;
  };
}

export interface SectionDetailResponseBody extends IResponseBody {
  data: {
    acl_role: RoleDetailSchema;
  };
}

export class SectionListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/acl-sections`;
  }

  async send(
    queryStrings?: SectionListQueryString
  ): Promise<SectionListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: {
          count: 1000,
          ...queryStrings,
        },
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async syncWithRoutes(): Promise<SectionDetailResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/sync-with-routes`
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async create(
    payload: ICreateRolePayload
  ): Promise<SectionCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/create`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }

  async update(
    roleId: string,
    payload: ICreateRolePayload
  ): Promise<SectionCreateResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath() + `/${roleId}/update`,
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
